export default "__VITE_PUBLIC_ASSET__eb385f75__"